<div class="frame">
    <div #container class="container">
        <div class="centerContent" *ngIf="showMessage">
            <div>
                <br/>
                <div class="deployText centerContent headerText">
                  No internet connection
                </div>
                <br/>
                <div class="deployText centerContent">
                  Please connect to the internet.
                </div>
            </div>
        </div>
    </div>
</div>
